import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  basketItemWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 272px)",
    maxHeight: "330px",
    overflow: "auto",

    "& .colorBlack": { color: "black !important" },
    "& .basketConProWrapper": {
      padding: "10px 0",
      borderBottom: "1px solid var(--blackOpacity10)",
    },
    "& .basketConProWrapper .basketConProTitle": {
      fontSize: "12px",
      textTransform: "capitalize",
      color: "var(--grey)",
      display: "block",
      textAlign: "right",
    },
    "& .basketItem": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    "& .basketItem:first-child": { paddingTop: "0" },
    "& .basketItem:last-child": { paddingBottom: "0" },
    "& .basketConProWrapper:last-child": {
      borderBottom: "none",
    },
    "& .basketItemPic, .ant-image": {
      width: "60px",
      height: "60px",
      backgroundColor: "var(--light)",
      borderRadius: "10px",
    },
    "& .basketItemPic img, .ant-image img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: "5px",
      padding: "5px",
    },
    "& .basketItemContent": {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      marginRight: "auto",
      marginLeft: "15px",
    },
    "& .basketItem .basketItemBtnWrapper": {
      display: "flex",
      alignItems: "center",
    },
    "& .basketItem .basketItemBtnWrapper .subInnerHeadingPara": {
      margin: "0 5px",
    },
    "& .basketItem .basketItemBtnWrapper .ant-btn-default": {
      padding: "2px 8px",
    },
    "& .basketItem .subInnerHeadingPara": {
      fontSize: "14px",
      textTransform: "capitalize",
    },
    "& .basketItem .subInnerHeading": { fontSize: "14px" },
    "& .basketRemoveItem.squareBtn.remove": {
      width: "35px",
      height: "35px",
      borderRadius: "5px",
      cursor: "pointer",
    },
  },
  basketCheckoutWrapper: {
    width: "100%",
    padding: "0 20px",
    position: "absolute",
    left: "50%",
    bottom: "0",
    transform: "translate(-50%, -20%)",

    "& .commonButton": { width: "100%" },
    "& .basketAmountWrapper": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
    },
    "& .basketButtonWrapper": {
      padding: "12px 45px",
      borderRadius: "30px",
      border: "none",
      outline: "none",
      transition: "0.3s all ease-in-out",
      background: "#00a3dc",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "50px",
    },
  },
});
